import { ProjectData, Tags, Languages, Software, ProjectStatus, Products, Contributors, Technologies, OrientationType } from '@structures/ProjectData';
import { FileType } from '@models';

export const DiabloIVVesselOfHatred: ProjectData = {
    summary: {
        id: "D4VOH",
        title: "Diablo IV - Vessel of Hatred",
        orientation: OrientationType.Portrait,
        aliases: ["D4VOH", "DIV", "Diablo", "D4-VOH", "D4 VoH"],
        filter: { settings: { pixelSize: 3 }},
        version: 1.059,
        status: ProjectStatus.Live,
        initial: new Date(2024, 10, 8),
        release: new Date(),
        previews:[{
            file: new URL("https://upload.wikimedia.org/wikipedia/en/1/18/Diablo_IV_Vessel_of_Hatred_key_art.png"),
            type: FileType.Image,
            description: "A heroic image of a magical looking man holding a bladed staff weapon, with the text 'Diablo IV Vessel of Hatred'.",
            caption: `Cover art for the game.`
        }],
        tags: {
            [Tags.Products]: [
                Products.Tools,
                Products.Games
            ],
            [Tags.Software]: [
                Software.VS
            ],
            [Tags.Languages]: [
                Languages.CPlus,
                Languages.CSharp
            ],
            [Tags.Technologies]: [
                Technologies.WPF
            ]
        },
        description: "Expansion game for Diablo 4."
    },
    details: {
        description: "Set in the newly introduced region of Nahantu, a jungle overrun by corruption and dark forces, Vessel of Hatred explores new narratives and challenges within the Diablo universe."
            + "<br/><br/>"
            + "The expansion introduces the Spiritborn class, a versatile new character with abilities derived from ancient jungle warriors. "
            + "<br/><br/>"
            + "Players also experience a new endgame dungeon designed for cooperative play, alongside an array of new items, abilities, and enhancements to the Paragon system.",
        gallery: [{
            file: new URL("https://www.youtube.com/embed/mtM0WpHEjWU?si=WOsRV5GBB2sJk4QX?controls=0"),
            type: FileType.Video,
            description: "",
            caption: "The gameplay trailer for the game!"
        }],
        contributions: [{
            contributor: Contributors.MakoInfused,
            roles: [{
                title: "Lead Tools Engineer",
                involvement: "Develop features and lead a team of engineers to produce enhancements of an internal game editor.",
                achievements: [
                    "Designed & implemented an entire plugin system for the proprietary game editor, paving the way for modular architecture.",
                    "Developed internal tooling to provide a build verification platform and systems, along with UI for a build launcher, reducing exceptions by over 2000% (700 to 30 per week).",
                    "Lead a strike team to improve editor performance by reducing startup time by ~1000% (from 4 minutes to 25 seconds)",
                    "Lead 6-9 engineers, providing metorship, technical direction and support for every step throughout the Software Development Lifecycle.",
                    "Programmed the groundwork for a dynamic typing system which simplfies the content generation pipeline.",
                    "Own critical areas of the editor, ensuring stability and providing support for content creators to make assets for the game."
                ]
            }]
        }]
    },
};

export default DiabloIVVesselOfHatred;